import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import React, { useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router';
import { useAsignatures } from '../asginatures/Asignatures';

const useStyles = makeStyles((theme) => ({
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
    // width: '80%',
  },
}));

export function useSeries() {
  const [series, setSeries] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    setIsLoading(true);
    fetch('https://api.edicionesmilenio.com/api/series')
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        setSeries(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return { series, setSeries, isLoading };
}

export default function Series() {
  const { series, setSeries, isLoading } = useSeries();
  const [name, setName] = React.useState('');
  const [description, setDescription] = React.useState('');
  const { asignatures } = useAsignatures();
  const [image, setImage] = React.useState('');
  const [asignature, setAsignature] = React.useState('');
  const [selectedSerie, setSelectedSerie] = React.useState(null);
  const navigate = useNavigate();

  const routeChange = (id) => {
    navigate(`/admin/series-update/${id}`);
  };

  const classes = useStyles();

  const columns = [
    {
      name: 'name',
      label: 'Nombre',
    },
    {
      name: 'createdAt',
      label: 'Fecha De Creación',
    },
    {
      name: 'actions',
      label: 'Herramientas',
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <Button
              color="primary"
              onClick={() => routeChange(series[dataIndex]?._id)}
            >
              <FaEdit />
            </Button>
          );
        },
      },
    },
  ];

  const handleDelete = async (rowsDeleted) => {
    const confirm = window.confirm(
      '¿Está seguro que desea eliminar las series seleccionadas?'
    );
    if (confirm) {
      rowsDeleted?.data?.forEach(async (row) => {
        let response = await fetch(
          `https://api.edicionesmilenio.com/api/series/${
            series[row?.dataIndex]?._id
          }`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        let data = await response.json();
        if (data.success) {
          setSeries(series.splice(row?.dataIndex, 1));

          setName('');
          setDescription('');
          setAsignature('');
          setImage('');
        }
      });
    }
  };

  useEffect(() => {
    if (selectedSerie) {
      setName(selectedSerie?.name);
      setDescription(selectedSerie?.description);
      setImage(selectedSerie?.image);
    }
  }, [selectedSerie]);

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p className={classes.formSpan}>
        Estimado administrador, desde esta sección podrás visualizar la lista de
        las series creadas a la fecha y autorizadas por la gerencia de Ediciones
        Mileno, ten mucha precaución de eliminar alguna de ellas, si ya cuenta
        con libros, o contenido asociado, este proceso no se puede recuperar.
      </p>
      {!isLoading ? (
        <MUIDataTable
          title={'Listado de asignaturas'}
          data={series}
          columns={columns}
          options={{
            filter: 'dropdown',
            onRowsDelete: (rowsDeleted) => {
              handleDelete(rowsDeleted);
            },
          }}
        />
      ) : (
        <CircularProgress color="primary" />
      )}
    </div>
  );
}
